"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getConfig = getConfig;
const config_shared_1 = __importDefault(require("@src/config-shared"));
const config_sk_1 = require("./config.sk");
const config_en_1 = require("./config.en");
function getConfig(locale = 'sk') {
    const frontendConfigs = {
        sk: config_sk_1.configFrontendSK,
        en: config_en_1.configFrontendEN,
    };
    return { ...config_shared_1.default, ...frontendConfigs[locale] };
}
const config = { ...config_shared_1.default, ...getConfig() };
exports.default = config;
